import {
  defineComponent, reactive, watch, PropType, VNode,
} from 'vue'
import GridItem from './GridItem.vue'
import { CollapseDirection, GridRowItem, MouseState } from './interface'

export default defineComponent({
  props: {
    row: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<(GridRowItem | string)[]>,
      default: () => ([]),
    },
    collapse: {
      type: Object as PropType<CollapseDirection>,
      default: () => ({}),
    },
  },
  emits: {
    click(e: MouseEvent) {
      return e !== undefined
    },
    mousedown(e: MouseEvent) {
      return e !== undefined
    },
    mouseenter(e: MouseEvent) {
      return e !== undefined
    },
    mouseleave(e: MouseEvent) {
      return e !== undefined
    },
    mouseup(e: MouseEvent) {
      return e !== undefined
    },
    'state-change'(state: MouseState) {
      return state !== undefined
    },
  },
  setup(props, { slots, emit }) {
    const state = reactive<MouseState>({
      pressing: false,
      hover: false,
    })

    watch(
      state,
      v => emit('state-change', v),
    )

    const bindings = {
      onClick: (e: MouseEvent) => emit('click', e),
      onMousedown: (e: MouseEvent) => {
        emit('mousedown', e)
        state.pressing = true
      },
      onMouseenter: (e: MouseEvent) => {
        emit('mouseenter', e)
        state.hover = true
      },
      onMouseleave: (e: MouseEvent) => {
        emit('mouseleave', e)
        state.hover = false
        state.pressing = false
      },
      onMouseup: (e: MouseEvent) => {
        emit('mouseup', e)
        state.pressing = false
      },
    }

    return () => <>
      {
        slots.handler && <GridItem
          row={props.row}
          column={'1 / -1'}
          {...bindings}
        >
          {slots.handler()}
        </GridItem>
      }
      {
        (slots.default?.() || [])
          .map(
            (m: VNode, i) => {
              const defaultColumn = `${i + 1} / ${i + 2}`
              const args = props.items[i]

              return <GridItem
                row={props.row}
                {
                  ...typeof (args) === 'object'
                    ? {
                      column: args.column || defaultColumn,
                      useCollapse: args.useCollapse,
                      collapse: props.collapse,
                      style: {
                        pointerEvents: args.preventEvent && 'none',
                      },
                    }
                    : { column: args || defaultColumn }
                }
                {...bindings}
              >
                {m}
              </GridItem>
            },
          )
      }
    </>
  },
})
